import core_libs_i18n from '@core/libs/i18n';
import core_libs_acl from '@core/libs/acl';


const {
  t
} = core_libs_i18n.useUtils();
const {
  canViewVerticalNavMenuHeader
} = core_libs_acl.useUtils();
 export default ({
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  render(h) {
    const span = h('span', {}, t(this.item.header));
    const icon = h('feather-icon', {
      props: {
        icon: 'MoreHorizontalIcon',
        size: '18'
      }
    });
    if (canViewVerticalNavMenuHeader(this.item)) {
      return h('li', {
        class: 'navigation-header text-truncate'
      }, [span, icon]);
    }
    return h();
  }
});

